import { useState, useEffect } from "react";

const MODULOS_LABELS = {
  ncs: "No Conformidades", fmea: "FMEA", plan_control: "Plan de Control",
  acciones: "Acciones Correctivas", auditorias: "Auditorías", prog_auditorias: "Programa Auditorías",
  analisis_causa: "Análisis de Causa", capabilidad: "Capabilidad / MSA", haccp: "HACCP",
  poes: "POEs", ots: "Órdenes de Trabajo", documentos: "Documentos",
  ingreso_materiales: "Ingreso Materiales", preprensa: "Pre Prensa", produccion: "Producción",
  tpm: "TPM Mantenimiento", huella_carbono: "Huella de Carbono", fsc: "FSC Arqueo",
  sustentabilidad: "Sustentabilidad", proveedores: "Proveedores", clientes: "Clientes",
  compras: "Compras", cotizacion: "Cotización", ventas: "Ventas", rrhh: "RRHH",
  capacitaciones: "Capacitaciones", hs: "H&S", ciberseguridad: "Ciberseguridad",
  stock_materiales: "Stock Materiales", despacho: "Despacho", aria: "ARIA — IA",
  dashboard_ca: "Dashboard CA", diseno_desarrollo: "Diseño y Desarrollo", oficina_tecnica: "Oficina Técnica",
  especificaciones_tecnicas: "Especificaciones Técnicas", usuarios: "Usuarios", importar_csv: "Importar CSV",
  assured_quality: "Assured Quality", trazabilidad: "Trazabilidad", costos_no_calidad: "Costos de No Calidad",
  cumplimiento_normas: "Cumplimiento de Normas", comunicados: "Comunicados Internos", onboarding: "Onboarding",
  escritorio_calidad: "Escritorio Calidad", consultor_hs: "ALQOS Asesor",
  centros_costo: "Centros de Costo", motor_costeo: "Motor de Costeo",
};

export default function BotonMapaProceso({ moduloKey, oscuro }) {
  const [mapa, setMapa] = useState(null);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    async function cargar() {
      try {
        const { supabase } = await import('./supabase');
        const { data } = await supabase.from('mapa_procesos').select('data');
        if (data && data.length > 0) {
          const todos = data.map(r => r.data);
          const found = todos.find(m => m.modulo_key === moduloKey);
          setMapa(found || null);
        } else {
          const local = JSON.parse(localStorage.getItem('alqos_mapa_procesos') || '[]');
          setMapa(local.find(m => m.modulo_key === moduloKey) || null);
        }
      } catch {
        const local = JSON.parse(localStorage.getItem('alqos_mapa_procesos') || '[]');
        setMapa(local.find(m => m.modulo_key === moduloKey) || null);
      }
    }
    cargar();
  }, [moduloKey]);

  const tieneContenido = mapa && (mapa.entradas?.length || mapa.salidas?.length || mapa.logica_adicional);
  if (!tieneContenido) return null;

  const cardBg = oscuro ? "#0d2160" : "white";
  const texto = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde = oscuro ? "#1e3a8a" : "#eee";
  const subtexto = oscuro ? "#9aabd4" : "#808085";

  return (
    <>
      <button
        onClick={() => setAbierto(true)}
        title="Ver mapa de proceso de este módulo"
        style={{
          background: "rgba(42,127,255,0.12)",
          border: "1px solid rgba(42,127,255,0.3)",
          color: "#2A7FFF",
          borderRadius: "8px",
          padding: "5px 10px",
          fontSize: "13px",
          cursor: "pointer",
          fontWeight: "600",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px"
        }}>
        🗺️ Mapa de Proceso
      </button>

      {abierto && (
        <div style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
          zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center",
          padding: "1rem"
        }}
          onClick={e => { if (e.target === e.currentTarget) setAbierto(false); }}>
          <div style={{
            background: cardBg, borderRadius: "16px", padding: "1.5rem",
            maxWidth: "550px", width: "100%", maxHeight: "80vh",
            overflowY: "auto", border: `1px solid ${borde}`,
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
              <div>
                <p style={{ fontSize: "11px", color: "#2A7FFF", fontWeight: "600", margin: "0 0 4px", textTransform: "uppercase", letterSpacing: ".1em" }}>🗺️ Mapa de Proceso</p>
                <p style={{ fontSize: "16px", fontWeight: "700", color: texto, margin: 0 }}>{MODULOS_LABELS[moduloKey] || moduloKey}</p>
              </div>
              <button onClick={() => setAbierto(false)}
                style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: subtexto }}>✕</button>
            </div>

            {mapa.entradas?.length > 0 && (
              <div style={{ marginBottom: "1rem" }}>
                <p style={{ fontSize: "12px", fontWeight: "700", color: "#2A7FFF", margin: "0 0 6px" }}>⬅️ Recibe datos de:</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {mapa.entradas.map(key => (
                    <span key={key} style={{ fontSize: "11px", background: oscuro ? "#091840" : "#eff6ff", color: "#2A7FFF", border: "1px solid #93c5fd", borderRadius: "7px", padding: "4px 8px", fontWeight: "600" }}>
                      {MODULOS_LABELS[key] || key}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {mapa.salidas?.length > 0 && (
              <div style={{ marginBottom: "1rem" }}>
                <p style={{ fontSize: "12px", fontWeight: "700", color: "#22c55e", margin: "0 0 6px" }}>➡️ Envía datos / dispara acciones en:</p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {mapa.salidas.map(key => (
                    <span key={key} style={{ fontSize: "11px", background: oscuro ? "#091840" : "#f0fdf4", color: "#22c55e", border: "1px solid #86efac", borderRadius: "7px", padding: "4px 8px", fontWeight: "600" }}>
                      {MODULOS_LABELS[key] || key}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {mapa.logica_adicional && (
              <div>
                <p style={{ fontSize: "12px", fontWeight: "700", color: texto, margin: "0 0 6px" }}>📝 Lógica adicional</p>
                <div style={{
                  fontSize: "12px", color: texto, lineHeight: "1.6",
                  whiteSpace: "pre-wrap",
                  background: oscuro ? "#091840" : "#f9f9ff",
                  borderRadius: "10px", padding: "0.8rem",
                  border: `1px solid ${borde}`
                }}>
                  {mapa.logica_adicional}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
